import styled from 'styled-components';
import { Divider } from '@99designs/emu';

export const TabsMenuDivider = styled(Divider)`
    margin-top: -6px;
`;
